import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { Box, Drawer, useMediaQuery } from '@mui/material';
import PerfectScrollbar from 'react-perfect-scrollbar';

import MenuList from './MenuList';
import homeLogo from 'assets/images/homelogo.png';
import MenuCard from './MenuCard';
import { drawerWidth, collapsedDrawerWidth } from 'store/constant';
import loadMenuFromLocalStorage from 'store/loadMenu';


const Sidebar = ({ drawerOpen, drawerToggle, window }) => {
    const theme = useTheme();
    const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));
    const [menuItems, setMenuItems] = useState([]);


    useEffect(() => {
        const items = loadMenuFromLocalStorage();
        setMenuItems(items);
    }, []);



    // Drawer Content
    const drawerContent = (
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            {/* Show logo on small screens */}
            {!matchUpMd && (
                <Box sx={{ display: 'flex', p: 2, mx: 'auto' }}>
                    <img src={homeLogo} alt="Trucred Logo" style={{ height: 40 }} />
                </Box>
            )}

            {/* Scrollable menu content */}
            <Box
                component={PerfectScrollbar}
                style={{
                    flexGrow: 1,
                    paddingLeft: drawerOpen ? '16px' : '8px',
                    paddingRight: drawerOpen ? '16px' : '8px',
                    height: matchUpMd ? 'auto' : 'calc(100vh - 56px)'
                }}
            >
                <MenuList items={menuItems} isCollapsed={!drawerOpen} />
            </Box>

            {/* Fixed footer card */}

            <Box sx={{ p: 1, mb: 9, borderTop: '1px solid white' }}>

                <MenuCard />
            </Box>

        </Box>
    );

    const container = window !== undefined ? () => window.document.body : undefined;

    return (
        <Box
            component="nav"
            sx={{
                flexShrink: { md: 0 },
                width: matchUpMd ? (drawerOpen ? drawerWidth : collapsedDrawerWidth) : 'auto'
            }}
            aria-label="sidebar menu"
        >
            <Drawer
                container={container}
                variant={matchUpMd ? 'persistent' : 'temporary'}
                anchor="left"
                open={drawerOpen}
                onClose={drawerToggle}
                ModalProps={{ keepMounted: true }}
                sx={{
                    width: drawerOpen ? drawerWidth : collapsedDrawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerOpen ? drawerWidth : collapsedDrawerWidth,
                        background: theme.palette.background.default,
                        color: '#FFFFFF',
                        borderRight: 'none',
                        overflowX: 'hidden',
                         zIndex: (theme) => theme.zIndex.appBar - 3,
                        transition: theme.transitions.create('width', {
                            easing: theme.transitions.easing.sharp,
                            duration: theme.transitions.duration.enteringScreen
                        }),
                        [theme.breakpoints.up('md')]: {
                            top: '88px'
                        }
                    }
                }}
            >
                {drawerContent}
            </Drawer>
        </Box>
    );
};

Sidebar.propTypes = {
    drawerOpen: PropTypes.bool,
    drawerToggle: PropTypes.func,
    window: PropTypes.object
};

export default Sidebar;
